import apiService from "../../api/api.service";
import {
  AiControlResponse,
  SendMessageRequest,
  SendMessageResponse,
  GetMessagesRequest,
  GetMessagesResponse,
} from "./tozy.types";

export const getAiControl = () =>
  apiService.get<AiControlResponse>("/ai/ai-control");

export const sendMessage = (data: SendMessageRequest) =>
  apiService.post<SendMessageResponse>("/ai/messages", data);

export const getMessages = (params?: GetMessagesRequest) =>
  apiService.get<GetMessagesResponse>("/ai/messages", { params });

